import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type PageWidth = 'list' | 'detail' | 'settings' | 'form' | 'full';

/**
 * The content width per page type. Lists, dashboards and detail pages stop at
 * 1680px so a table on an ultrawide screen stays readable; a detail page's card
 * grid limits its own line length and fills that width. Forms stop at 768px,
 * settings content next to its rail at 896px; planners and calendars take the
 * full width.
 */
const WIDTH_CLASSES: Record<PageWidth, string> = {
  list: 'max-w-screen-list',
  detail: 'max-w-screen-list',
  settings: 'max-w-4xl',
  form: 'max-w-3xl',
  full: '',
};

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  width?: PageWidth;
}

export function PageContainer({ width = 'list', className, children, ...props }: PageContainerProps) {
  return (
    <div className={cn('mx-auto w-full', WIDTH_CLASSES[width], className)} data-page-width={width} {...props}>
      {children}
    </div>
  );
}
